import { createFileRoute } from "@tanstack/react-router";
import { ComingSoonPage } from "@/components/layout/page-container.tsx";

export const Route = createFileRoute("/devices")({
  component: () => <ComingSoonPage title="设备管理" />,
});
